import { Injectable } from '@angular/core';

import { DatabaseService } from './base/database.service';
import { Base } from '../models/base.model';
import { HttpClient } from '@angular/common/http';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class MessageService extends DatabaseService<Message> {
  constructor(private http: HttpClient, private us: UserService) {
    super('cp_message');
    this.lambdaNames = {
      create: 'create_message',
      update: 'update_message',
      delete: 'delete_message',
    };
  }

  notifyMessageUploadedLambdaUrl = '';
  notifyMessageUploadedBucket = '';
  notifyMessageUploadedPrefix = '';

  async notifyMessageUploaded(path: string) {
    const body: NotifyMessageUploadedBody = {
      bucket: this.notifyMessageUploadedBucket,
      fileKey: this.notifyMessageUploadedPrefix + '/' + path,
    };

    const token = (await this.supabase.auth.getSession()).data.session
      ?.access_token;

    this.http.post(this.notifyMessageUploadedLambdaUrl, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
}

export class Message extends Base {
  thread_id?: string;
  author_user_id?: string;
  author_display_name?: string;
  value?: string;
  user_reads?: ReadEntry[];
  attachments: any;
  metadata: any;
  user_agent: any;
  text_search: any;
}

export interface ReadEntry {
  userId: string;
  device: string;
  timestamp: Date;
}

interface NotifyMessageUploadedBody {
  bucket: string;
  fileKey: string;
}
